<div class="page-container">
  <div class="page-content">
    <!-- Első betöltés: spinner -->
    @if (isFirstLoad) {
      <div class="loading-container">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Adatok betöltése...</p>
      </div>
    }

    <!-- Error state -->
    @if (error && !isLoading) {
      <div class="error-container">
        <div class="error-message">
          <mat-icon>error</mat-icon>
          <h3>{{ error }}</h3>
          <button mat-button color="primary" (click)="retryLoad()">
            <mat-icon>refresh</mat-icon>
            Újrapróbálás
          </button>
        </div>
      </div>
    }

    <!-- Filters + Table: mindig renderelve maradnak (nem pusztulnak el betöltés közben) -->
    @if (!isFirstLoad && !error) {
      <!-- Shared Filters -->
      <app-shared-filters
        [pageName]="'call_center_database'"
        [initialFilter]="currentFilter"
        [customStatusOptions]="callCenterStatusOptions"
        [callCenterStaff]="callCenterStaff"
        [useAssigneeFilter]="true"
        [lockAssigneeFilter]="isCallCenterEmployee()"
        [customSearchPlaceholder]="'Keresés (cégnév, adószám, cégjegyzékszám, Opten ID…)'"
        [showMainActivityFilter]="true"
        [mainActivityOptions]="mainActivityOptions"
        (mainActivitySearch)="onMainActivitySearch($event)"
        (filterChange)="onSharedFilterChange($event)">
      </app-shared-filters>
      
      <!-- Loading overlay a table felett (lapozás/szűrés közben) -->
      <div class="table-loading-wrapper" [class.is-loading]="isLoading">
        @if (isLoading) {
          <div class="table-loading-overlay">
            <mat-spinner diameter="36"></mat-spinner>
          </div>
        }
        <app-call-center-database-table 
          [title]="title"
          [data]="databaseData"
          [totalRecords]="totalRecords"
          [currentPage]="currentPage"
          [callCenterStaffInput]="callCenterStaff"
          [serverSidePagination]="true"
          (dataChanged)="onDataChanged()"
          (pageChanged)="onPageChange($event)"
          (sortChanged)="onSortChange($event)">
        </app-call-center-database-table>
      </div>
    }
  </div>
</div>
